import { useContext } from "react";
import { LocaleStringContext } from "./LocaleStringContext";

export const useLocaleString = (): string => {
  return useContext(LocaleStringContext);
};
